import React from 'react'
import bg from 'images/personas/bg-essentials.jpg'

export default function EssentialsIntro() {
  return (
    <section className="section" data-anchor="the_essentials">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box flex relative">
        <div className="col-12 flex flex-column relative z1">
          <div className="flex-auto">
            <h2 className="persona-title p4 sm-px0 sm-py3">The<br /> Essentials</h2>
          </div>

          <div>
            <img alt="" className="block" src={bg} />
          </div>
        </div>
      </div>
    </section>
  );
}
